<!-- eslint-disable max-len -->
<template>
  <div class="card" style="background-color: rgba(255,255,255,0.95); width: 50vw; min-width: 700px; min-height: 400px;">
    <div class="card-body" style="padding: 37px;">
      <template v-if="loadingFailed">
        <div style="margin: auto; max-width: 50vw;">
          <h1>Loading failed</h1>
          <p>Failed to load {{classTypeNameLower}} info.  Please try again later.</p>
        </div>
      </template>
      <template v-else-if="!hasLoadedPricingInfo">
        <blade-spinner />
      </template>
      <template v-else>
        <div style="display: flex; flex-direction: row; justify-content: center; margin: 20px; margin-bottom: 40px;">
          <template v-for="id of [0, 1, 2]">
            <div
              class="progress-circle"
              :style="(id <= flowState.currentPage) ? (`background-color: ${activeEnvironment().primaryColor || 'rgb(239, 139, 95)'};`) : (`background-color: rgb(0.1, 0.1, 0.1);`)"
              :key="id"
            >

              <div style="width: 200px; margin-left: -100px; text-align: center; margin-top: 10px;">{{progressDots[id]}}</div>
            </div>
            <div
              :key="id + '_line' + flowState.currentPage"
              :style="(id < flowState.currentPage) ? (`background-color: ${activeEnvironment().primaryColor || 'rgb(239, 139, 95)'};`) : (`background-color: rgb(0.1, 0.1, 0.1)};`)"
              v-if="id < 2"
              ref="line"
              class="progress-line"
            />
          </template>
        </div>
        <div style="margin: auto; max-width: 42vw; padding-top: 20px; padding-bottom: 30px;">
          <div v-if="flowState.currentPage === 0">
            <info-page
              :course="course"
              :paymentData="paymentData"
              @continue="changePaymentMethod"
              @coupon-applied="handleCouponApplied"
            />
          </div>
          <div v-else-if="flowState.currentPage === 1">
            <payment-page
              :course="course"
              :paymentData="paymentData"
              @payment-method-selected="selectPaymentMethod"
            />
          </div>
          <div v-else-if="flowState.currentPage === 2">
            <confirmation-page
              :course="course"
              :paymentData="paymentData"
              :paymentMethod="paymentMethod"
              @payment-success="$emit('course-purchased', paymentData.activePrice === 0)"
              @change-payment-method="changePaymentMethod"
              @coupon-applied="handleCouponApplied"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InfoPage from './purchase-flow-views/InfoPage';
import PaymentPage from './purchase-flow-views/PaymentPage';
import ConfirmationPage from './purchase-flow-views/ConfirmationPage';
import DropinContainer from './DropinContainer';

export default {
  components: {
    DropinContainer,
    InfoPage,
    PaymentPage,
    ConfirmationPage
  },
  props: {
    course: Object
  },
  mounted() {
    this.loadPrice();
  },
  computed: {
    ...mapGetters([
      'classTypeNameLower',
    ]),
  },
  methods: {
    ...mapActions([
      'getClassPurchaseData'
    ]),

    ...mapGetters([
      'activeEnvironment'
    ]),

    async loadPrice() {
      this.hasLoadedPricingInfo = false;
      try {
        const resp = await this.getClassPurchaseData({ classId: this.course._id });
        if (resp.hasPaid) {
          this.$emit('course-already-paid');
          return;
        }
        this.paymentData.activePrice = resp.price;
        this.paymentData.basePrice = resp.price;
        this.hasLoadedPricingInfo = true;
      } catch (ex) {
        console.error(ex);
        this.loadingFailed = true;
      }
    },

    changePaymentMethod() {
      if (this.paymentData.activePrice === 0) {
        this.flowState.currentPage = 2;
        return;
      }
      this.$set(this, 'paymentMethod', null);
      this.flowState.currentPage = 1;
    },
    selectPaymentMethod(method) {
      this.$set(this, 'paymentMethod', method);
      this.flowState.currentPage = 2;
    },
    handleCouponApplied(coupon) {
      if (coupon.coupon) {
        this.paymentData.isCouponActive = true;
        this.paymentData.activePrice = coupon.price;
        this.paymentData.couponCode = coupon.coupon.code;
        // TODO: update alert to use better UX?
        // eslint-disable-next-line no-alert
        alert(`Successfully applied coupon ${coupon.coupon.name}`);
      } else {
        this.paymentData.isCouponActive = false;
        this.paymentData.activePrice = this.paymentData.basePrice;
        this.paymentData.couponCode = '';
      }
    }
  },
  data() {
    return {
      paymentData: {
        isCouponActive: false,
        basePrice: -1,
        activePrice: -1,
        couponCode: ''
      },
      progressDots: [
        'Summary',
        'Payment Method',
        'Confirmation'
      ],
      flowState: {
        currentPage: 0
      },
      hasLoadedPricingInfo: false,
      loadingFailed: false,
      paymentMethod: null
    };
  }
};
</script>

<style lang="scss" scoped>
.spinner-container
{
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  min-height: 50px;
}

.progress-line
{
  width: 20vw;
  height: 1px;
  margin-top: 6px;
  background-color: black;
}

.progress-circle
{
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: black;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/braintree/ClassPurchaseFlow.vue